import { REPORT_TYPES, GRAPH_DATATYPE, QUALITATIVE_REPORT_LEVELS } from "../../../constants/app-constant";
import { getRandomUniqueColor, getLineGraphFormat } from "./format-utils";
import {
    VERTICALS,
    GRAPH_TYPES,
    CONSTANTS,
    useDynamicEntityColors,
} from "../../../constants/app-constant";
import { publicationPrintGenreFilterList, publicationOnlineGenreFilterList } from "../../NewsAndAnalysis/NewAnalysis/AnalysisGroup/filter-constant";

const { V_ONLINE, V_PRINT } = VERTICALS;
const { PIE, TABLE, BAR_STACKED_EQUAL_HEIGHT, LINE, BAR_VERTICAL } = GRAPH_TYPES;
const {
    REPORTS: { TYPES },
} = CONSTANTS;

const {
    ENTITY,
    KEYWORD,
    JOURNALIST,
    CITY,
    PUBLICATION,
} = QUALITATIVE_REPORT_LEVELS;


export const getPublicationsFromResponse = (d = []) => {
    const result = d;
    const publications = result &&
        result[result.sequence[0]].returnData.publications &&
        result[result.sequence[0]].returnData.publications.map((publication) => publication.publication);
    return publications;
}

export const getKeywordsFromResponse = (d = []) => {
    const result = d;
    const keywords = result &&
        result[result.sequence[0]].returnData.keywords
    return keywords;
}
export const getEntitiesFromResponse = (d = []) => {
    const result = d;
    const entities = result && result[result.sequence[0]].returnData.entities.map((ent) => ent.entity_name);
    return entities;
}

export const newFormatPublicationData = (
    d = [],
    report_type,
    type,
    selectedInlineGraphType,
    selectedInlineSentiment,
    selectedInlineEntity,
    selectedInlinePublication,
    selectedInlineGenre,
) => {

    const isEntityLevel = /entity/i.test(report_type);

    const isJournalistLevel = /journalist/i.test(report_type);

    const isKeywordLevel = /keyword/i.test(report_type);

    const isPublicationLevel = /publication/i.test(report_type);

    const isCityLevel = /city/i.test(report_type);

    const isNewEntityLevel = /newentity/i.test(report_type);

    const level =
        (isNewEntityLevel) ? 'NewEntity' :
            (isEntityLevel) ? ENTITY :
                (isJournalistLevel) ? JOURNALIST :
                    (isKeywordLevel) ? KEYWORD :
                        "No Level";

    const isTrend = /trend/i.test(report_type);

    const isTonality = /tonality/i.test(report_type);

    const currentMeasure = (report_type) => {
        const measures = {
            NOA: "article_count",
            CCM: "ccmtotal",
            MAV: "mavtotal",
            Index: "indextotal",
            WC: "wordcounttotal",
            Reach: "reachtotal",
        };
        const noaRegex = /noa/i;
        const ccmRegex = /ccm/i;
        const mavRegex = /mav/i;
        const indexRegex = /index/i;
        const wordCountRegex = /wordCount/i;
        const reachRegex = /reach/i;
        if (noaRegex.test(report_type)) {
            return measures.NOA;
        } else if (ccmRegex.test(report_type)) {
            return measures.CCM;
        } else if (mavRegex.test(report_type)) {
            return measures.MAV;
        } else if (indexRegex.test(report_type)) {
            return measures.Index;
        } else if (wordCountRegex.test(report_type)) {
            return measures.WC;
        } else if (reachRegex.test(report_type)) {
            return measures.Reach;
        } else {
            console.log("No report name match found");
            return;
        }
    }
    const measure = currentMeasure(report_type);
    if (isTrend) {
        return newFormatDataByTrend(
            d,
            level,
            selectedInlineGraphType,
            measure,
            selectedInlineEntity.value,
            selectedInlinePublication.value,
            selectedInlineGenre.value,
            type,
        );
    }
    else if (isTonality) {
        return newFormatDataByTonality(
            d,
            level,
            selectedInlineGraphType,
            measure,
            selectedInlineEntity.value,
            selectedInlinePublication.value,
            selectedInlineSentiment.value,
            selectedInlineGenre.value,
            type,
        );
    }
    else {
        return newFormatDataBySOV(
            d,
            level,
            selectedInlineGraphType,
            measure,
            selectedInlineEntity.value,
            selectedInlinePublication.value,
            selectedInlineGenre.value,
        );
    }
};

//{datasets: {label: "", backgroundColor: "", barThcikness: "", borderColor: ""/[], borderWidth: 1, data: [], 
//fill: false, lineTension: 0}}
//{labels: [], datasets: [], hcPieChartData: [{name, y, backgroundColor}]}

const newFormatDataBySOV = (d = [], level, graphType, currentMeasure, selectedEntity, selectedPublication, selectedGenre) => {
    const result = d;
    const graphData = result && result[result.sequence[0]].returnData.graphdata;
    const dataObj = result && result[result?.sequence[0]].returnData;
    const entities = dataObj && dataObj.entities;
    const labels = entities.map((ent) => ent.entity_name);
    const datasets = [];
    const publications = getPublicationsFromResponse(d);
    if (level === 'NewEntity') {
        const allgenere = ["Mainlines", "Regional", "Periodical", "Financial"]
        const colors = getRandomUniqueColor(publications.length);
        allgenere && allgenere.forEach((genere, idx) => {
            const label = genere;
            const backgroundColor = colors[idx];
            const data = [];
            entities && entities.forEach(({ entity_name }) => {
                let currVal = 0;
                if (graphData[entity_name] &&
                    graphData[entity_name].hasOwnProperty(genere)) {
                    currVal = parseData(graphData[entity_name][genere][currentMeasure], true);
                }
                data.push(currVal);
            });
            datasets.push({ label, backgroundColor, data });
        });
        return { labels, datasets };
    }
    else if (level === ENTITY && level !== 'NewEntity') {
        const level1Keys = graphData && Object.keys(graphData);
        const level2Keys = [];
        level1Keys && level1Keys.forEach((val) => {
            const subLevelKeys = Object.keys(graphData[val]);
            subLevelKeys && subLevelKeys.forEach((genre) => {
                level2Keys.indexOf(genre) < 0 && level2Keys.push(genre);
            });
        });
        const colors = getRandomUniqueColor(publications.length);
        publications && publications.filter((v, i) => i < 10).forEach((publication, idx) => {
            const label = publication;
            const backgroundColor = colors[idx];
            const data = [];
            entities && entities.forEach(({ entity_name }) => {
                let currVal = 0;
                if (graphData[publication] &&
                    graphData[publication].hasOwnProperty(selectedGenre) &&
                    graphData[publication][selectedGenre].hasOwnProperty(entity_name)) {
                    currVal = parseData(graphData[publication][selectedGenre][entity_name][currentMeasure], true);
                }
                data.push(currVal);
            });
            datasets.push({ label, backgroundColor, data });
        });
        return { labels, datasets };
    } else {
        const journalistData = dataObj && dataObj.journalist;
        const journalists = journalistData && journalistData.map((j) => j.source_name);
        const keywords = dataObj && dataObj.keywords;
        const level1Keys = (level === KEYWORD) ? keywords : journalists;
        // const genres = [];
        // level1Keys && level1Keys.forEach((lv1) => {
        //     if (graphData[lv1][selectedPublication]) {
        //         const subLevelKeys = Object.keys(graphData[lv1][selectedPublication]);
        //         subLevelKeys && subLevelKeys.forEach((genre) => {
        //             genres.indexOf(genre) < 0 && genres.push(genre);
        //         });
        //     }
        // });
        const colors = getRandomUniqueColor(publications.length);
        const legendSet = [];
        const legendSetLength = Math.ceil(publications.length / 10);
        for (let x = 1, y = 0; x <= 1; x++) {
            const set = [];
            publications && publications.filter((v, i) => (i >= y && i < (x * 10))).forEach((publication, idx) => {
                const label = publication;
                const backgroundColor = colors[idx];
                const data = [];
                level1Keys.forEach((lv1) => {
                    let currVal = 0;
                    if (
                        graphData[lv1].hasOwnProperty(publication) &&
                        graphData[lv1][publication].hasOwnProperty(selectedGenre) &&
                        graphData[lv1][publication][selectedGenre].hasOwnProperty(selectedEntity)
                    ) {
                        currVal = parseData(graphData[lv1][publication][selectedGenre][selectedEntity][currentMeasure], true);
                    }
                    data.push(currVal);
                });
                set.push({ label, backgroundColor, data });
            });
            legendSet.push({ labels: level1Keys, datasets: set });
            y = x * 10;
        }
        return legendSet;
    }
}
//{labels: [], datasets: [], hcPieChartData: [{name, y, backgroundColor}]}
const newFormatDataByTonality = (
    d = [],
    level,
    graphType,
    currentMeasure,
    selectedEntity,
    selectedPublication,
    selectedSentiment,
    selectedGenre,
    type,
) => {

    const result = d;
    const graphData = result && result[result.sequence[0]].returnData.graphdata;
    const dataObj = result && result[result?.sequence[0]].returnData;
    const entities = dataObj && dataObj.entities;
    const tonalities = dataObj && dataObj.tonality;
    const datasets = [];
    const labels = entities && entities.map((ent) => ent.entity_name);
    const publications = getPublicationsFromResponse(d);
    const colors = getRandomUniqueColor(publications.length);

    if (level === ENTITY) {
        const level3Keys = graphData &&
            graphData.hasOwnProperty(selectedSentiment) &&
            graphData[selectedSentiment].hasOwnProperty(selectedPublication) &&
            Object.keys(graphData[selectedSentiment][selectedPublication]);
        const publicationColors = getRandomUniqueColor(publications.length);
        const legendSet = [];
        const legendSetLength = Math.ceil(publications.length / 10);
        for (let x = 1, y = 0; x <= 1; x++) {
            const set = [];
            publications && publications.filter((v, i) => (i >= y && i < (x * 10))).forEach((publication, idx) => {
                const label = publication;
                const backgroundColor = colors[idx];
                const data = [];
                labels && labels.forEach((ent) => {
                    let currVal = 0;
                    if (
                        graphData.hasOwnProperty(selectedSentiment) &&
                        graphData[selectedSentiment].hasOwnProperty(publication) &&
                        graphData[selectedSentiment][publication].hasOwnProperty(selectedGenre) &&
                        graphData[selectedSentiment][publication][selectedGenre].hasOwnProperty(ent)
                    ) {
                        currVal = parseData(graphData[selectedSentiment][publication][selectedGenre][ent][currentMeasure], true);
                    }
                    data.push(currVal);
                });
                set.push({ label, backgroundColor, data });
            });
            legendSet.push({ labels, datasets });
            y = x * 10;
        }
        return legendSet;
    } else {
        const journalistData = dataObj && dataObj.journalist;
        const journalists = journalistData && journalistData.map((j) => j.source_name);
        const keywords = dataObj && dataObj.keywords;
        const level2Keys = (level === KEYWORD) ? keywords : journalists;
        const printGenreList = publicationPrintGenreFilterList.map((val) => val.value);
        const onlineGenreList = publicationOnlineGenreFilterList.map((val) => val.value);
        const loopList = (type === V_ONLINE) ? onlineGenreList : printGenreList;
        const publicationColors = getRandomUniqueColor(publications.length);
        const legendSet = [];
        const legendSetLength = Math.ceil(publications.length / 10);
        for (let x = 1, y = 0; x <= 1; x++) {
            const set = [];
            publications && publications.filter((v, i) => (i >= y && i < (x * 10))).forEach((publication, idx) => {
                const label = publication;
                const backgroundColor = publicationColors[idx];
                const data = [];
                level2Keys && level2Keys.forEach((val) => {
                    let currVal = 0;
                    if (
                        graphData.hasOwnProperty(selectedSentiment) &&
                        graphData[selectedSentiment].hasOwnProperty(val) &&
                        graphData[selectedSentiment][val].hasOwnProperty(publication) &&
                        graphData[selectedSentiment][val][publication].hasOwnProperty(selectedGenre) &&
                        graphData[selectedSentiment][val][publication][selectedGenre].hasOwnProperty(selectedEntity)
                    ) {
                        currVal = parseData(
                            graphData[selectedSentiment][val][publication][selectedGenre][selectedEntity][currentMeasure],
                            true
                        );
                    }
                    data.push(currVal);
                });
                set.push({ label, backgroundColor, data });
            });
            legendSet.push({ labels: level2Keys, datasets });
            y = x * 10;
        }
        return legendSet;
    }


}

//{datasets: {label: "", backgroundColor: "", barThcikness: "", borderColor: ""/[], borderWidth: 1, data: [], fill: false, lineTension: 0}}
//{labels: [], datasets: [], hcPieChartData: [{name, y, backgroundColor}]}

const newFormatDataByTrend = (d = [], level, graphType, currentMeasure, selectedEntity, selectedFilter, selectedGenre, type) => {
    const result = d;
    const graphData = result && result[result.sequence[0]].returnData.graphdata;
    const dataObj = result && result[result?.sequence[0]].returnData;
    const entities = dataObj && dataObj.entities;
    const labels = entities.map((ent) => ent.entity_name);
    const datasets = [];
    const level1Keys = graphData && Object.keys(graphData).sort();
    const entityColors = getRandomUniqueColor(entities.length);
    const publications = getPublicationsFromResponse(d);
    const publicationColors = getRandomUniqueColor(publications.length);
    if (level === ENTITY) {
        entities && entities.forEach((ent, idx) => {
            const label = ent.entity_name;
            const backgroundColor = (useDynamicEntityColors) ? (ent.color_code !== "#000000") ? ent.color_code : entityColors[idx] : entityColors[idx];
            const data = [];
            level1Keys && level1Keys.forEach((date) => {
                let currVal = 0;
                if (
                    graphData[date].hasOwnProperty(selectedFilter) &&
                    graphData[date][selectedFilter].hasOwnProperty(selectedGenre) &&
                    graphData[date][selectedFilter][selectedGenre].hasOwnProperty(label)
                ) {
                    currVal = parseData(graphData[date][selectedFilter][selectedGenre][label][currentMeasure], true);
                }
                data.push(currVal);
            });
            datasets.push({ label, backgroundColor, data });
        })
        return { labels: level1Keys, datasets };
    } else {
        const journalistData = dataObj && dataObj.journalist;
        const journalists = journalistData && journalistData.map((j) => j.source_name);
        const keywords = dataObj && dataObj.keywords;
        const level2Keys = (level === KEYWORD) ? keywords : journalists;
        const level2Colors = getRandomUniqueColor(level2Keys.length);
        const legendSet = [];
        const legendSetLength = Math.ceil(level2Keys.length / 10);
        for (let x = 1, y = 0; x <= 1; x++) {
            const set = [];
            level2Keys && level2Keys.filter((v, i) => i < 10).forEach((lv2, idx) => {
                const label = lv2;
                const backgroundColor = level2Colors[idx];
                const data = [];
                level1Keys && level1Keys.forEach((date) => {
                    let currVal = 0;
                    if (
                        graphData[date].hasOwnProperty(lv2) &&
                        graphData[date][lv2].hasOwnProperty(selectedFilter) &&
                        graphData[date][lv2][selectedFilter].hasOwnProperty(selectedGenre) &&
                        graphData[date][lv2][selectedFilter][selectedGenre].hasOwnProperty(selectedEntity)
                    ) {
                        currVal = parseData(graphData[date][lv2][selectedFilter][selectedGenre][selectedEntity][currentMeasure]);
                    }
                    data.push(currVal);
                });
                set.push({ label, backgroundColor, data });
            });
            legendSet.push({ labels: level1Keys, datasets });
            y = x * 10;
        }
        return legendSet;
    }
}

const parseData = (value, float = false) => {
    let return_value = (float) ? Math.round(parseFloat(value * 100, 10)) / 100 : parseInt(value, 10);
    if (Number.isNaN(return_value)) {
        let newevalue = value.replace(/,/g, '')
        newevalue = (float) ? Math.round(parseFloat(newevalue * 100, 10)) / 100 : parseInt(newevalue, 10)
        return newevalue;
    }
    return return_value;
}
